import React, { useState, useContext, useEffect } from 'react';
import { UserContext } from '../components/userContext';
import { useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import clsx from 'clsx';
import defaultBg from '../images/clv.png';

import { makeStyles, withStyles, lighten } from '@material-ui/core/styles';
import { 
  Button,
  Checkbox,
  FormGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography, 
  Grid,
  InputBase,

} from '@material-ui/core'
import Rating from '@material-ui/lab/Rating';

import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import AddCircleRoundedIcon from '@material-ui/icons/AddCircleRounded';


const useStyles = makeStyles((theme) => ({
  showError: {
    minWidth: 450, 
    minHeight: 450, 
    margin: '0 auto', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    '@media (max-width:599px)': {
      minWidth: 270, 
      minHeight: 270, 
    },
  },
  errorContent: {
    fontSize: 20, 
    fontWeight: 500, 
    textAlign: 'center', 
    marginBottom: '-20px',
    '@media (max-width:599px)': {
      fontSize: 14,
      marginBottom: '-10px',
      minWidth: 270, 
    },
  },
  container: {
    boxShadow: theme.shadows[4],
    width: '75%', 
    margin: '0 auto',
    minWidth: 275,
    transition: 'all 0.5s ease',
    '@media (max-width:750px)': {
      width: '100%',
      margin: 0,
    }
  },
  cover: {
    width: 'calc(100% - 100px)', 
    position:'relative', 
    left: 100, 
    transition: 'all 0.5s ease',
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent'
    },
    '@media (max-width:750px)': {
      left: 0,
      width: '100%'
    }
  },
  coverExpanded: {
    left: 0,
    width: '100%'
  },
  form: {
    width: '40%',
    minWidth: 350,
    maxHeight: 495, 
    display: 'flex', 
    alignItems: 'center', 
    flexDirection: 'column', 
    padding: '20px 36px', 
    backgroundColor: 'rgba(26, 26, 26, 0.9)', 
    overflowY: 'auto', 
    position: 'relative', 
    left: '-100px',
    transition: 'all 0.5s ease',
    '& .MuiFormLabel-root': {
      fontSize: 15
    },
    '@media (max-width:750px)': {
      minWidth: 275, 
      left: 0,
      padding: '8px 32px', 
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(18, 18, 18, 0.975)'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: 'rgba(10, 10, 10, 0.8)'
    }
  },
    formExpanded: {
    width: '100%',
    left: 0,
    backgroundColor: 'rgba(26, 26, 26, 1)', 
  },
  expandButton: {
    width: 38,
    height: 38,
    position: 'absolute',
    right: 0,
    padding: 0,
    top: 'calc(50% - 19px)',
    zIndex: 1
  },
  textField: {
    width: '100%',
    '& .MuiInputBase-input':{
      fontSize: 15
    },
    '& .MuiSvgIcon-root': {
      width: '0.75em',
      height: '0.75em'
    },
    '& .MuiTypography-body1': {
      fontSize: 14
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: 'rgb(163, 102, 255)',
    },
    '& .Mui-focused': {  
      '& .MuiOutlinedInput-notchedOutline': {
        border: '2px solid rgb(163, 102, 255)'
      }
    },
    marginBottom: 12,
    '& .MuiInput-underline:after': {
      borderBottomColor: 'rgb(163, 102, 255)'
    },
    '& .MuiInput-root': {
      color: 'white',
      foontWeight: 300
    }
  },
  select: {
    width: '100px',
    flexGrow: 1,
    marginLeft: 12, 
    backgroundColor: 'rgba(22, 22, 22, 1)',
    '& .MuiSelect-selectMenu': {
      paddingLeft: 8
    },
    '&:before, &:after': {
      border: 'none',
      content: 'none'
    },
    //   borderBottomColor: 'transparent'
    
    // '& .MuiInput-underline:after': {
    //   border: 'none'
    // }
  },
  button: {
    borderRadius: 0,
    '&:hover': {
      // backgroundColor: 'rgb(163, 102, 255)',
      color: 'rgb(163, 102, 255)'
    }
  }
}));

export default function MovieForm() {
  const classes = useStyles();
  const { user, setFetchMovies } = useContext(UserContext);
  const [ inputVal, setInputVal ] = useState({title: '', genre: '', year: null, rating: null, duration: null, description: '', review: '', image_url: ''});
  const [ expand, setExpand ] = useState(false)
  const [ open, setOpen] = useState(false);
  let history = useHistory();
  let { itemId } = useParams();
  
  useEffect(() => { 
    const fetchData = async () => {
      if (itemId) {
        const result = await axios.get(`https://backendexample.sanbersy.com/api/data-movie/${itemId}`);
        setOpen(Boolean(result.data.id));
        const { id, title, image_url, genre, rating, year, duration, description, review } = result.data; 
        setInputVal({title, image_url, genre, rating, year, duration, description, review}); 
      } else {
        setOpen(true)
      }
    }
    fetchData();
  },[]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const { title, image_url, genre, rating, year, duration, description, review } = inputVal;

    if (itemId) {
      axios.put(`https://backendexample.sanbersy.com/api/data-movie/${itemId}`, 
      {title, image_url, genre, rating, year, duration, description, review}, 
      {headers: {"Authorization" : "Bearer " + user.token}})
      .then(() => setFetchMovies(true)
      );
      console.log("ok")
    } else {
      axios.post(`https://backendexample.sanbersy.com/api/data-movie`, 
      {title, image_url, genre, rating, year, duration, description, review}, 
      {headers: {"Authorization" : "Bearer " + user.token}})
      .then(() => setFetchMovies(true));
    }
    setInputVal({title: '', genre: '', year: null, rating: null, duration: null, description: '', review: '', image_url: ''});
    history.push(`/${user.email}/dashboard/movie-editor/list`);
  }

  const handleChange = (event) => {
    let name = event.currentTarget.name;
    let value = event.currentTarget.value
    if (name === "year" || name === "duration" ) {
      setInputVal({...inputVal, [name]: parseInt(value) });  
    } else if (name === "rating"){
      setInputVal({...inputVal, [name]: parseInt(value * 2) });  
    } else setInputVal({...inputVal, [name]: value.toString()});
    console.log(inputVal)
  }

  const selectChange = (event) => {
    setInputVal({...inputVal, rating: parseInt(event.target.value) });  
  }

  const goBack = () => {
    history.push(`/${user.email}/dashboard/movie-editor/list`);
  }

  const handleExpand = () => {
    setExpand(!expand);
  }

  return (
    <>
      {open ?
        <Paper className={classes.container}>
          <div 
            style={{  
              background: inputVal.image_url ? `url(${inputVal.image_url}) center/cover no-repeat rgba(26, 26, 26, 1)` : `url(${defaultBg}) center/82% auto no-repeat rgba(26, 26, 26, 1)`
            }}
            className={clsx(classes.cover, expand && classes.coverExpanded)}
          >
            <IconButton 
              onClick={handleExpand}
              disableFocusRipple
              disableRipple
              className={classes.expandButton}  
            >
              {expand ? <ChevronLeftRoundedIcon style={{fontSize: '1.8rem'}} /> : <ChevronRightRoundedIcon style={{fontSize: '1.8rem'}} />}
            </IconButton>
            <form onSubmit={handleSubmit} className={clsx(classes.form, expand && classes.formExpanded)}>
              {itemId ? 
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 4}}>
                  <span style={{fontSize: 20, fontWeight: 500, marginRight: '12px'}}>
                    Edit Movie (Id : {itemId})
                  </span>
                  <EditRoundedIcon fontSize='small'/>
                </div>
              :
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 4}}>
                  <span style={{fontSize: 20, fontWeight: 500, marginRight: '12px'}}>
                    Add New Movie
                  </span>
                  <AddCircleRoundedIcon style={{color: 'rgb(144, 144, 144)'}} fontSize='small'/>
                </div>
              }
              <TextField
                className={classes.textField}
                required
                id="title"
                name="title"
                label="Title"
                placeholder="E.g. The Craft: Legacy, Prometheus 2, etc."
                type="text"
                onChange={handleChange}
                value={inputVal.title}
                autoComplete="title"
                autoFocus
              />
              <TextField
                className={classes.textField}
                required
                id="genre"
                name="genre"
                label="Genre"
                placeholder="E.g. Mystery, Action, Horror, etc."
                type="text"
                onChange={handleChange}
                value={inputVal.genre}
                autoComplete="genre"
              />
              <TextField
                className={classes.textField}
                required
                id="year"
                name="year"
                label="Release Year"
                placeholder="E.g. 2021, etc."
                type="number"
                InputProps={{inputProps: {min: 1995, max: new Date().getFullYear()}}}
                onChange={handleChange}
                value={inputVal.year}
                autoComplete="year"
              />
              <TextField
                className={classes.textField}
                required
                id="duration"
                name="duration"
                label="Duration (minutes)"
                placeholder="E.g. 120, etc."
                type="number"
                onChange={handleChange}
                value={inputVal.duration}
                autoComplete="duration"
              />
              <div style={{width: '100%', margin: '12px 0 24px 0'}}>
                <Typography id="discrete-slider" style={{color: 'rgba(144, 144, 144, 1)', fontSize: '12px', alignSelf: 'flex-start'}}>
                  Rating (0 to 10)
                </Typography>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', alignSelf: 'flex-start'}}> 
                  <Rating name="rating" value={inputVal.rating/2} precision={0.5} onChange={handleChange} />
                  <Select
                    className={classes.select}
                    value={inputVal.rating}
                    onChange={selectChange}
                  >
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((v, i) => {
                      return <MenuItem value={v} style={{lineHeight: 1}}>{v}</MenuItem>  
                    })}
                  </Select>
                </div>
              </div>
              <TextField
                className={classes.textField}
                required
                multiline
                variant="outlined"
                id="description"
                name="description"
                label="Description"
                placeholder="E.g. F9 (also known as F9: The Fast Saga and Fast & Furious 9) is a 2021 American action film directed by Justin Lin from a screenplay by Daniel Casey and Lin..."
                type="text"
                onChange={handleChange}
                value={inputVal.description}
                autoComplete="description"
              />
              <TextField
                className={classes.textField}
                required
                multiline
                variant="outlined"
                id="review"
                name="review"
                label="Review"
                placeholder="E.g. Great movie that succeeds on almost every level..."
                type="text"
                onChange={handleChange}
                value={inputVal.review}
                autoComplete="review"
              />
              <TextField
                className={classes.textField}
                required
                id="image_url"
                name="image_url"
                label="Image Url"
                placeholder="E.g. https://i.ytimg.com/vi/6K4T0nGU4pg/maxresdefault.jpg, etc."
                type="text"
                onChange={handleChange}
                value={inputVal.image_url}
                autoComplete="image_url"
              />
              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                <Button type="submit" className={classes.button}>
                  Submit
                </Button>
                &nbsp;
                <Button onClick={goBack} className={classes.button}>
                  Cancel
                </Button>
              </div>
            </form>
          </div>
        </Paper>
      :
        <>
          <div className={classes.errorContent}>Error! : Id Not Found</div>
          <div 
            className={classes.showError}
            style={{  
              background: `url(${defaultBg}) center/auto 100% no-repeat rgba(30, 30, 30, 0.5)`
            }}
          />
        </>
      }
    </>
  )
}
